import { defineCatalogue } from '../../i18n';

export const ptMessages = {
  'operations.title': 'Operações',
  'nav.label': 'Operações',
  loadError: 'Não foi possível carregar o catálogo de operações.',
  empty: 'Nenhuma operação cadastrada.',

  'tab.coleta': 'Coleta',
  'tab.inteligencia': 'Inteligência',
  'tab.midia': 'Mídia',

  'header.operation': 'Operação',
  'header.provider': 'Provedor',
  'header.key': 'Chave',
  'header.providerCost': 'Custo do provedor',
  'header.multiplier': 'Multiplicador',
  'header.pays': 'Organização paga',

  'key.placeholder': 'Escolha uma chave',
  'key.none': 'Não usa chave',
  'key.missing.chip': 'Sem chave · não coleta',
  save: 'Salvar',
  'pays.credits': 'créditos',

  'unit.page.input': 'cr/página',
  'unit.page.pays': 'por página',
  'unit.profile.input': 'cr/perfil',
  'unit.profile.pays': 'por perfil',
  'unit.item.input': 'cr/post',
  'unit.item.pays': 'por post',
  'unit.tokensIn.input': 'cr/1M entrada',
  'unit.tokensIn.pays': 'por 1M de entrada',
  'unit.tokensOut.input': 'cr/1M saída',
  'unit.tokensOut.pays': 'por 1M de saída',

  'provider.socialcrawl': 'SocialCrawl',
  'provider.openrouter': 'OpenRouter',
  'provider.openai': 'OpenAI',
  'provider.google_ai': 'Google AI',
  'provider.anthropic': 'Anthropic',
  'provider.platform': 'Plataforma',

  'subsection.midia': 'Mídia',
  'subsection.task.fallback': 'Outras tarefas',
  'operation.unnamed': 'Operação sem nome',

  'aria.provider': 'Provedor, {operation}',
  'aria.key': 'Chave, {operation}',
  'aria.providerCost': 'Custo do provedor, {operation}',
  'aria.providerCost.input': 'Custo do provedor por entrada, {operation}',
  'aria.providerCost.output': 'Custo do provedor por saída, {operation}',
  'aria.multiplier': 'Multiplicador, {operation}',
  'aria.save': 'Salvar, {operation}',

  'inference.label': 'Inferência',
  'inference.noModel': 'sem modelo configurado',
  'inference.edit': 'Editar',
  'inference.collapse': 'Recolher',
  'inference.aria.textarea': 'Configuração de inferência (JSON), {operation}',
  'inference.priority.default': 'Prioridade padrão',
  'inference.priority.low': 'Prioridade baixa (metade do preço)',
  'inference.aria.priority': 'Prioridade, {operation}',
  'inference.fallback': 'Voltar à prioridade padrão após N adiamentos (vazio: nunca)',
  'inference.aria.fallback': 'Adiamentos antes da prioridade padrão, {operation}',

  // Keyed by the operation key's own suffix -- `post.stats` from
  // `instagram.post.stats`, `chat` from `intelligence.chat` -- so
  // one entry names the operation on every network or provider it runs on.
  'operation.post.stats.name': 'Posts do feed',
  'operation.post_stats.name': 'Métricas completas de um post',
  'operation.post_likers.name': 'Curtidores de um post',
  'operation.post.comments.name': 'Comentários de um post',
  'operation.reel.stats.name': 'Reels',
  'operation.reel.comments.name': 'Comentários de um reel',
  'operation.story.sweep.name': 'Varredura de stories',
  'operation.audio.fanout.name': 'Busca de áudio',
  'operation.chat.name': 'Resposta do agente',
  'operation.post_access.name': 'Acesso à inteligência de um post',
  'operation.post_intel.name': 'Inteligência de um post',
  'operation.profile_account.name': 'Perfil de uma conta',
  'operation.stance_comment.name': 'Posicionamento de um comentário',
  'operation.cluster_summary.name': 'Resumo de um grupo',
  'operation.comment_intelligence.name': 'Inteligência de comentários',
  'operation.post_digest.name': 'Resumo diário',
  'operation.index.name': 'Indexação de mídia',
  'operation.match.name': 'Correspondência de mídia',
} as const;

export const enMessages: Record<keyof typeof ptMessages, string> = {
  'operations.title': 'Operations',
  'nav.label': 'Operations',
  loadError: 'Could not load the operation catalogue.',
  empty: 'No operation registered.',

  'tab.coleta': 'Collection',
  'tab.inteligencia': 'Intelligence',
  'tab.midia': 'Media',

  'header.operation': 'Operation',
  'header.provider': 'Provider',
  'header.key': 'Key',
  'header.providerCost': 'Provider cost',
  'header.multiplier': 'Multiplier',
  'header.pays': 'Organisation pays',

  'key.placeholder': 'Choose a key',
  'key.none': 'Uses no key',
  'key.missing.chip': 'No key · not collecting',
  save: 'Save',
  'pays.credits': 'credits',

  'unit.page.input': 'cr/page',
  'unit.page.pays': 'per page',
  'unit.profile.input': 'cr/profile',
  'unit.profile.pays': 'per profile',
  'unit.item.input': 'cr/post',
  'unit.item.pays': 'per post',
  'unit.tokensIn.input': 'cr/1M input',
  'unit.tokensIn.pays': 'per 1M input',
  'unit.tokensOut.input': 'cr/1M output',
  'unit.tokensOut.pays': 'per 1M output',

  'provider.socialcrawl': 'SocialCrawl',
  'provider.openrouter': 'OpenRouter',
  'provider.openai': 'OpenAI',
  'provider.google_ai': 'Google AI',
  'provider.anthropic': 'Anthropic',
  'provider.platform': 'Platform',

  'subsection.midia': 'Media',
  'subsection.task.fallback': 'Other tasks',
  'operation.unnamed': 'Unnamed operation',

  'aria.provider': 'Provider, {operation}',
  'aria.key': 'Key, {operation}',
  'aria.providerCost': 'Provider cost, {operation}',
  'aria.providerCost.input': 'Provider cost per input, {operation}',
  'aria.providerCost.output': 'Provider cost per output, {operation}',
  'aria.multiplier': 'Multiplier, {operation}',
  'aria.save': 'Save, {operation}',

  'inference.label': 'Inference',
  'inference.noModel': 'no model configured',
  'inference.edit': 'Edit',
  'inference.collapse': 'Collapse',
  'inference.aria.textarea': 'Inference configuration (JSON), {operation}',
  'inference.priority.default': 'Default priority',
  'inference.priority.low': 'Low priority (half price)',
  'inference.aria.priority': 'Priority, {operation}',
  'inference.fallback': 'Fall back to default priority after N deferrals (empty: never)',
  'inference.aria.fallback': 'Deferrals before default priority, {operation}',

  'operation.post.stats.name': 'Feed posts',
  'operation.post_stats.name': 'A post’s full metrics',
  'operation.post_likers.name': 'A post’s likers',
  'operation.post.comments.name': 'Post comments',
  'operation.reel.stats.name': 'Reels',
  'operation.reel.comments.name': 'Reel comments',
  'operation.story.sweep.name': 'Story sweep',
  'operation.audio.fanout.name': 'Audio lookup',
  'operation.chat.name': 'Agent reply',
  'operation.post_access.name': 'Post intelligence access',
  'operation.post_intel.name': 'Post intelligence',
  'operation.profile_account.name': 'Account profile',
  'operation.stance_comment.name': 'Comment stance',
  'operation.cluster_summary.name': 'Cluster summary',
  'operation.comment_intelligence.name': 'Comment intelligence',
  'operation.post_digest.name': 'Daily digest',
  'operation.index.name': 'Media indexing',
  'operation.match.name': 'Media matching',
};

export const operationsCatalogue = defineCatalogue(ptMessages, enMessages);
export const t = operationsCatalogue.t;

/** The part of an operation key that names the operation, independent of
 *  which network runs it (`instagram.post.stats` and `tiktok.post.stats`
 *  share `post.stats`); an intelligence operation is its task (`chat`). */
export function operationSuffix(operationKey: string): string {
  const segments = operationKey.split('.');
  if (segments[0] === 'intelligence' || segments[0] === 'media') {
    return segments[1] ?? operationKey;
  }
  return segments.slice(1).join('.') || operationKey;
}

/** An operation this table has no copy for still gets a row an admin can
 *  price, under a generic name: raw keys never reach the screen (owner
 *  ruling, 2026-09-27). */
export function operationNameOf(operationKey: string): string {
  const key = `operation.${operationSuffix(operationKey)}.name`;
  return key in ptMessages ? t(key as keyof typeof ptMessages) : t('operation.unnamed');
}

/** `null` for anything outside the `intelligence.*` vocabulary: only those
 *  keys ever have a `task_inference_configs` row to show below them. */
export function taskOf(operationKey: string): string | null {
  const segments = operationKey.split('.');
  return segments[0] === 'intelligence' ? (segments[1] ?? null) : null;
}
